module.exports = __webpack_public_path__ + "static/media/UBC.3e977b64.svg";